
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_9duf6_1xfs9_13",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_9duf6_1xfs9_1",
  "refresh": "awsui_refresh_9duf6_1xfs9_34",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_9duf6_1xfs9_1",
  "root": "awsui_root_9duf6_1xfs9_76",
  "interior": "awsui_interior_9duf6_1xfs9_109",
  "dropdown": "awsui_dropdown_9duf6_1xfs9_13",
  "use-portal": "awsui_use-portal_9duf6_1xfs9_119",
  "is-empty": "awsui_is-empty_9duf6_1xfs9_199",
  "dropdown-drop-up": "awsui_dropdown-drop-up_9duf6_1xfs9_206",
  "with-limited-width": "awsui_with-limited-width_9duf6_1xfs9_210",
  "dropdown-drop-left": "awsui_dropdown-drop-left_9duf6_1xfs9_213",
  "dropdown-drop-right": "awsui_dropdown-drop-right_9duf6_1xfs9_216",
  "occupy-entire-width": "awsui_occupy-entire-width_9duf6_1xfs9_219",
  "use-flexible-width": "awsui_use-flexible-width_9duf6_1xfs9_222",
  "hide-block-border": "awsui_hide-block-border_9duf6_1xfs9_230",
  "open": "awsui_open_9duf6_1xfs9_239",
  "nowrap": "awsui_nowrap_9duf6_1xfs9_248",
  "dropdown-content": "awsui_dropdown-content_9duf6_1xfs9_13",
  "stretch-trigger-height": "awsui_stretch-trigger-height_9duf6_1xfs9_259"
};
  